<div class="card">
  <div class="card-body p-0">
    <div *ngIf="isLoading" class="text-center p-5">
      <div class="spinner-border text-success" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div *ngIf="!isLoading && data.length === 0" class="text-center p-5">
      <p class="mb-0">{{ emptyMessage }}</p>
    </div>

    <div *ngIf="!isLoading && data.length > 0" class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th class="border-0" *ngFor="let column of columns">{{ column.header }}</th>
            <th class="border-0 text-end" *ngIf="showActions">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data">
            <ng-container *ngFor="let column of columns">
              <td *ngIf="column.icon">
                <i [class]="column.icon + ' text-success me-2'"></i>
                {{ item[column.field] }}
              </td>
              
              <td *ngIf="column.muted && !column.icon" class="text-muted">
                {{ item[column.field] }}
              </td>
              
              <td *ngIf="column.badge && !column.icon && !column.muted">
                <span class="badge rounded-pill" 
                      [class.bg-success]="item[column.field] === column.successValue"
                      [class.bg-danger]="item[column.field] !== column.successValue">
                  {{ item[column.field] }}
                </span>
              </td>
              
              <td *ngIf="!column.icon && !column.muted && !column.badge">
                {{ column.isDate ? (item[column.field] | date: 'short') : item[column.field] }}
              </td>
            </ng-container>
            
            <td *ngIf="showActions" class="text-end">
              <ng-container *ngTemplateOutlet="actionsTemplate || defaultActionsTemplate; context: {item: item}"></ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #defaultActionsTemplate let-item="item">
  <button *ngIf="showEditButton" class="btn btn-icon btn-light-primary btn-sm me-2" 
          (click)="onEdit.emit(item)">
    <i class="bi bi-pencil"></i>
  </button>
  <button *ngIf="showToggleButton" class="btn btn-icon btn-sm me-2"
          [class.btn-light-success]="item[stateField] === successStateValue"
          [class.btn-light-secondary]="item[stateField] !== successStateValue"
          (click)="onToggle.emit(item)"
          [disabled]="isTogglingId === item.id">
    <span *ngIf="isTogglingId === item.id" class="spinner-border spinner-border-sm"></span>
    <i *ngIf="isTogglingId !== item.id" 
       [class]="item[stateField] === successStateValue ? 'bi bi-toggle-on' : 'bi bi-toggle-off'">
    </i>
  </button>
  <button *ngIf="showDeleteButton" class="btn btn-icon btn-light-danger btn-sm" 
          (click)="onDelete.emit(item)">
    <i class="bi bi-trash"></i>
  </button>
</ng-template>
